import {
  type GetTags200Result,
  type IndexRequestSchema,
  tagsApi,
} from '@api/services/merchants';

const getTags = async (
  requestSchema?: IndexRequestSchema,
): Promise<GetTags200Result> => {
  const { data } = await tagsApi.getTags(requestSchema ?? {});

  if ('result' in data && data.result) return data.result;

  throw new Error('Empty response result');
};

export default getTags;
